export { FAQScanModule } from "./FAQScanModule";
export type { FAQScanProps, FAQScanModuleProps } from "./types";
